// extracted by mini-css-extract-plugin
module.exports = {"ErrorCard":"styles_ErrorCard__17BFH","ErrorLogo":"styles_ErrorLogo__2p9sd","ErrorContent":"styles_ErrorContent__1mnRL"};